import React from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { MetricaKPI } from '../../types/indicadores';
import { metricasKpiService } from '../../services';

const fields: ResourceField<MetricaKPI>[] = [
  { name: 'kpi', label: 'KPI (ID)', type: 'number' },
  { name: 'data_referencia', label: 'Data de referência', type: 'date' },
  { name: 'valor_medido', label: 'Valor medido', type: 'number' },
  { name: 'valor_meta', label: 'Meta do período', type: 'number' },
  { name: 'responsavel_analise', label: 'Responsável' }
];

export const MetricasKpiFormPage: React.FC = () => (
  <ResourceFormPage
    title="Registrar métrica de KPI"
    description="Informe valores medidos para o indicador."
    fields={fields}
    service={ metricasKpiService }
    redirectPath="/admin/indicadores/metricas-kpi"
    cancelPath="/admin/indicadores/metricas-kpi"
  />
);
